import type React from "react"

interface FooterTextProps {
  text?: React.ReactNode
}

export const FooterText: React.FC<FooterTextProps> = ({ text }) => {
  if (!text) return null

  return (
    <div className="flex-none pb-6">
      <div className="font-nunito mx-auto rounded-md bg-gray-50 p-3 text-xs text-gray-600">{typeof text === "string" ? <p>{text}</p> : text}</div>
    </div>
  )
}
